var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"bg-top"},[_c('div',{staticClass:"container"},[_c('h1',{staticClass:"tit"},[_c('strong',[_vm._v("Lifening")]),_vm._v(" PRODUCTS ")]),_c('p',{staticClass:"desc mt-2"},[_vm._v("현재를 가꾸는 당신에게, "),_c('span',{staticClass:"mbr"}),_vm._v("라이프닝"),_c('span',{staticClass:"brs"}),_vm._v("Lifening, to you")])])])
}]

export { render, staticRenderFns }